var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bind"},[_c('div',[_vm._v("请在\"闪易\"App中扫描该二维码")])])
}]

export { render, staticRenderFns }